
import {merge as observableMerge, fromEvent as observableFromEvent, Observable, BehaviorSubject} from 'rxjs';

import {distinctUntilChanged, debounceTime,  map } from 'rxjs/operators';
import {Component , ElementRef , OnInit , ViewChild} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {LevelService} from '../../../../core/services/level.service';
import {DataSource} from '@angular/cdk/collections';
import {fuseAnimations} from '../../../../core/animations';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';



import {FuseUtils} from '../../../../core/fuseUtils';
import {FormGroup} from '@angular/forms';
import {LevelFormDialogComponent} from './setting-form/setting-form.component';
import {FuseConfigService} from '../../../../core/services/config.service';
import { EventService } from '../../../../core/services/event.service';

@Component({
    selector: 'level-settings-page',
    templateUrl: './level-settings.component.html',
    styleUrls: ['./level-settings.component.scss'],
    animations: fuseAnimations,
    standalone: false
})
export class LevelSettingsComponent implements OnInit {
  levels: FilesDataSource | null;
  displayedColumns = [ 'level', 'status', 'sort', 'badge' ];
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild('filter', {static: true}) filter: ElementRef;
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  dialogRef: any;

  constructor (private http: HttpClient , private eventLevelsService: LevelService,
               public dialog: MatDialog,  public snackBar: MatSnackBar, public fuseConfig: FuseConfigService,
               public eventService: EventService) {
  }

  ngOnInit () {
    this.getDataType();
  }

  getImage(name) {
    return this.eventService.getFileStream(name);
  }

  getDataType () {
    this.levels = new FilesDataSource(this.eventLevelsService , this.paginator , this.sort);
    observableFromEvent(this.filter.nativeElement , 'keyup').pipe(
      debounceTime(150),
      distinctUntilChanged(),)
      .subscribe(() => {
        if (!this.levels) {
          return;
        }
        this.levels.filter = this.filter.nativeElement.value;
      });
  }

  newLevel () {
    this.dialogRef = this.dialog.open(LevelFormDialogComponent , {
      panelClass: 'contact-form-dialog' ,
      width: '600px',
      data: {
        action: 'new'
      }
    });

    this.dialogRef.afterClosed()
      .subscribe((response: any) => {
        const data = response[0].value;
        data.file = response[1];
        this.eventLevelsService.addEventLevel(data).subscribe((res) => {
          if (res) {
            this.snackBar.open('Organization type added.', '', {duration: 2500});
            this.eventLevelsService.getLevels().then();
          }
        }, error => {
          this.snackBar.open('Add failed.', '', {duration: 2500});
        } );
      });

  }

  editLevel (level) {
    this.dialogRef = this.dialog.open(LevelFormDialogComponent , {
      panelClass: 'contact-form-dialog' ,
      width: '600px',
      data: {
        type: level ,
        action: 'edit'
      }
    });

    this.dialogRef.afterClosed()
      .subscribe(response => {
        if (!response) {
          return;
        }
        console.log(response);
        const actionType: string = response[ 0 ];
        const data = response[ 1 ].value;
        data.file = response[2];
        data.id = level.id;
        switch (actionType) {
          /**
           * Save
           */
          case 'save':


            this.eventLevelsService.addEventLevel(data).subscribe((res) => {
              if (res) {
                this.snackBar.open('Organization type updated.', '', {duration: 2500});
                this.eventLevelsService.getLevels().then();
              }
            }, error => {
              this.snackBar.open('Update failed.', '', {duration: 2500});
            });
            break;
          /**
           * Delete
           */
          case 'delete':
            this.eventLevelsService.deleteEventLevel(level.id).subscribe((res) => {
              if (res) {
                this.snackBar.open('Organization type deleted.', '', {duration: 2500});
                this.eventLevelsService.getLevels().then();
              }
            }, error => {
              this.snackBar.open('Delete failed.', '', {duration: 2500});
            });

            break;
        }
      });
  }
}

export class FilesDataSource extends DataSource<any> {
  _filterChange = new BehaviorSubject('');
  _filteredDataChange = new BehaviorSubject('');

  get filteredData (): any {
    return this._filteredDataChange.value;
  }

  set filteredData (value: any) {
    this._filteredDataChange.next(value);
  }

  get filter (): string {
    return this._filterChange.value;
  }

  set filter (filter: string) {
    this._filterChange.next(filter);
  }

  constructor (private eventLevelsService: LevelService ,
               private _paginator: MatPaginator ,
               private _sort: MatSort) {
    super();
    this.filteredData = this.eventLevelsService.levels;
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect (): Observable<any[]> {
    const displayDataChanges = [
      this.eventLevelsService.onLevelChanged ,
      this._paginator.page ,
      this._filterChange ,
      this._sort.sortChange
    ];

    return observableMerge(...displayDataChanges).pipe(map(() => {
      let data = this.eventLevelsService.levels.slice();

      data = this.filterData(data);

      this.filteredData = [ ...data ];

      data = this.sortData(data);

      // Grab the page's slice of data.
      const startIndex = this._paginator.pageIndex * this._paginator.pageSize;
      return data.splice(startIndex , this._paginator.pageSize);
    }));
  }

  filterData (data) {
    console.log(data);
    if (!this.filter) {
      return data;
    }
    return FuseUtils.filterArrayByString(data , this.filter);
  }

  sortData (data): any[] {
    if (!this._sort.active || this._sort.direction === '') {
      return data;
    }

    return data.sort((a , b) => {
      let propertyA: number | string = '';
      let propertyB: number | string = '';
      switch (this._sort.active) {
        case 'level':
          [ propertyA , propertyB ] = [ a.level , b.level ];
          break;
        case 'status':
          [ propertyA , propertyB ] = [ a.status , b.status ];
          break;
        case 'sort':
          [ propertyA , propertyB ] = [ a.sort , b.sort ];
          break;

      }

      const valueA = isNaN(+propertyA) ? propertyA : +propertyA;
      const valueB = isNaN(+propertyB) ? propertyB : +propertyB;

      return (valueA < valueB ? -1 : 1) * (this._sort.direction === 'asc' ? 1 : -1);
    });
  }

  disconnect () {
  }
}
